import { createSelector } from 'reselect'

import {
  FETCH_LOCATIONS_PENDING,
  FETCH_LOCATIONS_FULFILLED,
  FETCH_LOCATIONS_REJECTED,
  FETCH_LOCATIONS_CHILDREN_PENDING,
  FETCH_LOCATIONS_CHILDREN_FULFILLED,
  FETCH_LOCATIONS_CHILDREN_REJECTED,
  FETCH_FYLKER_PENDING,
  FETCH_FYLKER_FULFILLED,
  FETCH_FYLKER_REJECTED,
} from './LocationsActions'

const initialState = {
  counties: [],
  isFetching: false,
  hasFetched: false,
  // canonical post-2020 fylker from the api - the values artist search accepts as `fylke`
  fylker: [],
  isFetchingFylker: false,
  hasFetchedFylker: false,
}

const locationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LOCATIONS_PENDING: {
      return {
        ...state,
        counties: [],
        isFetching: true,
      }
    }
    case FETCH_LOCATIONS_FULFILLED: {
      return {
        ...state,
        counties: action.payload.data,
        isFetching: false,
        hasFetched: true,
      }
    }
    case FETCH_LOCATIONS_REJECTED: {
      return {
        ...state,
        counties: [],
        isFetching: false,
        hasFetched: true,
      }
    }

    case FETCH_LOCATIONS_CHILDREN_PENDING: {
      return {
        ...state,
        isFetching: true,
      }
    }

    case FETCH_LOCATIONS_CHILDREN_FULFILLED: {
      const newCounties = [...state.counties]
      const newCountiesIndex = newCounties.findIndex(
        county => county.id === action.payload.parentId,
      )
      if (newCountiesIndex !== -1) {
        newCounties[newCountiesIndex] = {
          ...newCounties[newCountiesIndex],
          children: action.payload.data,
        }
      }

      return {
        ...state,
        counties: newCounties,
        isFetching: false,
      }
    }

    case FETCH_FYLKER_PENDING: {
      return {
        ...state,
        isFetchingFylker: true,
      }
    }
    case FETCH_FYLKER_FULFILLED: {
      return {
        ...state,
        fylker: action.payload.data,
        isFetchingFylker: false,
        hasFetchedFylker: true,
      }
    }
    case FETCH_FYLKER_REJECTED: {
      return {
        ...state,
        isFetchingFylker: false,
        hasFetchedFylker: true,
      }
    }

    case FETCH_LOCATIONS_CHILDREN_REJECTED: {
      return {
        ...state,
        isFetching: false,
      }
    }
    default: {
      return state
    }
  }
}

export default locationsReducer

const locationsState = state => state.locations

export const hasCountiesLoadedSelector = state => locationsState(state).hasFetched
export const getCounties = createSelector(
  locationsState,
  state => state.counties,
)

export const hasFylkerLoadedSelector = state => locationsState(state).hasFetchedFylker
export const getFylkerSelector = createSelector(
  locationsState,
  state => state.fylker,
)
export const getFylkeNamesSelector = createSelector(
  getFylkerSelector,
  fylker => fylker.map(fylke => fylke.name),
)
